export const commonDateFormat = 'YYYY-MM-DD';